exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-lista[data-v-448d62ba]{vertical-align:bottom}.panel[data-v-448d62ba]{border-left:1px solid #e1e1e1}.buttons[data-v-448d62ba]{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-448d62ba","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/Modalinforme.vue
// module id = 2199
// module chunks = 2